import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link as RouterLink, useMatch } from 'react-router-dom';
import { Link, StudyString, useLocalizeMessage } from 'libs.nucleus';
import ScheduleCardWrapper from './components/schedule_card_wrapper.component';
import { getRouteLink } from '../../helpers/links.helpers';
import { isParticipantDeactivated, isParticipantInactive } from '../../helpers/participants.helpers';
import { useCurrentEnvironment } from '../../hooks/use_current_environment';
export const NonVisitSchedule = ({ nonVisitData, participant, setCurrentVisit, setIsActivityListModalOpen, }) => {
    const translate = useLocalizeMessage();
    const match = useMatch('/site/study/:studyId/participants/:participantId/*');
    const participantId = match?.params.participantId;
    const { environment } = useCurrentEnvironment();
    const onVisitScheduleClick = (visit) => {
        setCurrentVisit({
            c_visit: '',
            c_name: visit.c_name ?? '',
            c_group: visit?.c_group ?? '',
            c_window_start: Date.now(),
            c_window_end: Date.now(),
            c_open_queries: 0,
            c_completed_assignments: 0,
            c_completed_assignments_for_site: 0,
            c_sequence: 0,
            assignments: visit.assignments ?? 0,
            total_activities_count: visit.assignments ?? 0,
            customVisitType: 'non_visit_schedule',
        });
        setIsActivityListModalOpen();
    };
    return nonVisitData.map((visit) => {
        return (_jsx(ScheduleCardWrapper, { "data-testid": `visit-schedule-${visit.c_group}`, showActionBtn: !isParticipantDeactivated(participant) && !isParticipantInactive(participant), onActionBtnClick: () => onVisitScheduleClick(visit), children: _jsxs("div", { className: 'col-span-2', children: [_jsx("div", { className: 'flex gap-2', "data-testid": `visit-title-${visit.c_group}`, children: _jsx(Link, { LinkComponent: RouterLink, to: getRouteLink(`participants/${participantId}/non-visit/${visit.c_group}`, environment), "data-testid": 'visit-name', children: _jsx(StudyString, { children: visit.c_name }) }) }), _jsx("div", { children: _jsx("span", { className: 'text-gray-500', "data-testid": `visit-assessments-${visit.c_group}`, children: translate('label.visit_schedule.activities', {
                                assignments: visit.assignments ?? 0,
                                count: visit.assignments ?? 0,
                            }) }) })] }) }, visit.c_group));
    });
};
